import React from 'react';
import { string, bool } from 'prop-types';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const SEOPlaceholder = ({ color, showLoadingAnimation }) => {
  return (
    <ComponentPlaceholder
      height={180}
      rows={4}
      color={color}
      showLoadingAnimation={showLoadingAnimation}
    />
  );
};

SEOPlaceholder.propTypes = {
  color: string,
  showLoadingAnimation: bool
};

SEOPlaceholder.defaultProps = {
  color: '#E0E0E0',
  showLoadingAnimation: false
};

export { SEOPlaceholder };
